import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=53347bef&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53347bef')) {
      api.createRecord('53347bef', component.options)
    } else {
      api.reload('53347bef', component.options)
    }
    module.hot.accept("./offers.vue?vue&type=template&id=53347bef&", function () {
      api.rerender('53347bef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2FWueGFO6DSPu/JS/comp/offers.vue"
export default component.exports